const signatureChainListStatus = {
  ALL: 'ALL',
  TODO: 'TODO',
  PENDING: 'PENDING',
  SIGNED: 'SIGNED',
  FAILED: {
    FAILED: 'FAILED',
    DECLINED: 'DECLINED',
    SUSPENDED: 'SUSPENDED',
    DELETED: 'DELETED',
    WITHDRAWN: 'WITHDRAWN'
  }
}
export default signatureChainListStatus
